// @flow

import React, { Fragment } from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  birthCountry?: ?string,
  birthCity?: ?string,
  birthYear?: ?string,
};

/**
 * ArtistBirthText
 *
 * @param {Props} props
 * @returns {Node}
 */
export function ArtistBirthText({ birthCountry, birthCity, birthYear }: Props): Node {
  return birthCountry || birthYear || birthCity ? (
    <Fragment>
      {/* Has only year or only birthCity (no translation required) */}
      {(!birthCity && !birthCountry && birthYear) || (!birthCountry && !birthYear && birthCity)}
      {/* Has country and no year */}
      {birthCountry && !birthYear ? (
        <FormattedMessage id={`countries.${birthCountry}`}>
          {(bornCountry: string) =>
            `${birthCity || ''}${birthCity && bornCountry ? ', ' : ''}${bornCountry}`
          }
        </FormattedMessage>
      ) : null}
      {/* Has year and country and/or city */}
      {birthYear && birthCountry ? (
        <FormattedMessage id={`countries.${birthCountry}`}>
          {(bornCountry: string) => (
            <FormattedMessage
              id="components.artist.bornIn"
              values={{
                year: birthYear || '',
                location: `${birthCity || ''}${birthCity && bornCountry ? ', ' : ''}${bornCountry}`,
              }}
            >
              {(label: string) => label}
            </FormattedMessage>
          )}
        </FormattedMessage>
      ) : null}
      {/* Has year and city and no country */}
      {birthYear && birthCity && !birthCountry ? (
        <FormattedMessage
          id="components.artist.bornIn"
          values={{
            year: birthYear || '',
            location: birthCity,
          }}
        >
          {(label: string) => label}
        </FormattedMessage>
      ) : null}
    </Fragment>
  ) : null;
}
